import React from 'react';
import styles from './index.css';

export const ErrorMessage = ({message, showIcon, cssFlag}) => (
    <div aria-atomic="true" className={cssFlag ? styles.errorMessageDiv : styles.apiErrorMessageDiv}>
        {showIcon && (
            <span className="uxf-icon align-middle p-1 m-auto">
                <svg
                    aria-hidden="true"
                    focusable="false"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path
                        d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                        fill="#D24625"
                        fillRule="nonzero"
                    />
                </svg>
            </span>
        )}
        <p className={cssFlag ? styles.errorMessage : styles.apiErrorMessage}>{message}</p>
    </div>
);
